import { render, staticRenderFns } from "./HotVideoData.vue?vue&type=template&id=5ed44581&scoped=true"
import script from "./HotVideoData.vue?vue&type=script&lang=js"
export * from "./HotVideoData.vue?vue&type=script&lang=js"
import style0 from "./HotVideoData.vue?vue&type=style&index=0&id=5ed44581&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed44581",
  null
  
)

export default component.exports